import React from 'react';
import { MuxProvider, LANG } from '@manulife/mux';
import useShallowEqualSelector from '../../CustomHooks/useShallowEqualSelector';
import { BRAND_THEME } from '../../utils/AppConstants';

/**
 * WrappedMuxProvider
 * Abstracts away initializing the MuxProvider wrapper from src/index.js. This needs to be its own component,
 * since we can only access useSelector as a child of index.js, and we need `language` to initialize the provider.
 */
const WrappedMuxProvider = ({ children }) => {
    const { language, isOtip } = useShallowEqualSelector((state) => ({
        language: state.Authentication.language,
        isOtip: state.Context.isOtip,
    }));

    // `lang` is assumed to be either en-CA or fr-CA; if it's neither, default to en-CA
    const lang = language === LANG.FR_CA ? LANG.FR_CA : LANG.EN_CA;

    // OTIP will be the only customization allowed
    const theme = isOtip ? BRAND_THEME.OTIP : BRAND_THEME.DEFAULT;

    return (
        <MuxProvider
            themeProvider={{ theme }}
            langProvider={{ lang }}
            navigationProvider={{ isSignedIn: true }} // App state is always signed in
        >
            {children}
        </MuxProvider>
    );
};

export default WrappedMuxProvider;
